"use client"

import Link from "next/link"
import { ShieldCheck } from "lucide-react"

export function Footer() {
  return (
    <footer className="bg-[#0F172A] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <ShieldCheck className="h-6 w-6 text-[#0EA5E9]" />
              <span className="font-bold">HIPAA Ready Check</span>
            </div>
            <p className="text-sm text-[#94A3B8]">
              Helping healthcare organizations achieve and maintain HIPAA compliance.
            </p>
          </div>
          <div>
            <h4 className="font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li><Link href="/self-assessment" className="hover:text-white transition-colors">Free Assessment</Link></li>
              <li><Link href="/hipaa-ready-pro" className="hover:text-white transition-colors">HIPAA Ready Pro</Link></li>
              <li><Link href="/hipaa-guide" className="hover:text-white transition-colors">HIPAA Guide</Link></li>
              <li><Link href="/compare/hipaa-compliance-services" className="hover:text-white transition-colors">Compare Approaches</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li><Link href="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link href="/resources" className="hover:text-white transition-colors">Resources</Link></li>
              <li><Link href="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li><Link href="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link href="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#1E293B] pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-sm text-[#94A3B8] mb-4 md:mb-0">
              © 2025 HIPAA Ready Check. All rights reserved.
            </p>
            <p className="text-sm text-[#94A3B8]">
              Powered by{" "}
              <a href="https://inventivehq.com" target="_blank" rel="noopener noreferrer" className="text-[#0EA5E9] hover:text-white transition-colors">
                InventiveHQ
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
